import { CommonDateBridge } from '@lg/shared'
import { FrontendLanguageBridge } from './bridges/frontend-language-bridge.js'
import { IdbService } from './services/idb.service.js'
import { CommonSys } from '@lg/shared'
import Confetti from 'canvas-confetti'

export const Ramda = CommonSys.Ramda
export const wait = CommonSys.wait

export { FrontendScreenBridge as Screen } from './bridges/frontend-screen-bridge.js'
export { FrontendAppBridge as App } from './bridges/frontend-app-bridge.js'
export { FrontendLanguageBridge as Language } from './bridges/frontend-language-bridge.js'
export { FrontendLayoutBridge as Layout } from './bridges/frontend-layout-bridge.js'
export { FrontendStorageBridge as Storage } from './bridges/frontend-storage-bridge.js'
export { FrontendProcessBridge as Process } from './bridges/frontend-process-bridge.js'
export { FrontendSystemBridge as System } from './bridges/frontend-system-bridge.js'
export * as Audit from './bridges/frontend-audit-bridge.js'
export * as Data from './bridges/frontend-data-bridge.js'
export * as Debug from '@lg/shared/bridges/debug'
export * as Math from '@lg/shared/bridges/math'
export * as RateLimiting from '@lg/shared/bridges/rate-limiting'
export * as Text from './bridges/frontend-text-bridge.js'
export { FrontendUserBridge as User } from './bridges/frontend-user-bridge.js'
export * as Version from '@lg/shared/bridges/version'
export { Types } from '@lg/shared'

export type { MainScreenClass, DialogScreenClass } from '@lg/shared'

const idbService = new IdbService()
export { idbService as Idb }
export { Confetti }

export async function getHttpClient() {
	return import('axios').then((module) => module.default)
}

export const Date = new CommonDateBridge(FrontendLanguageBridge)
